// 是否可选已删除状态
export const getDisabled = (item, isCheckDelete) => {
  if (isCheckDelete) {
    return false
  }
  return item.status === 1
}
// 可选已删除时，展示已删除标签
export const getShowSpan = (item, isCheckDelete) => {
  if (!isCheckDelete) {
    return false
  }
  return item.status === 1
}
